import { Ability, AbilityBuilder } from '@casl/ability';
import { store } from '../_helpers/store'

const ability = new Ability();

store.subscribe(() => {
  let auth = store.getState().authentication

  ability.update(defineRulesFor(auth));
})


const defineRulesFor = (auth) => {
  const permissions = auth.permissions;
  const { can, rules } = new AbilityBuilder();

  if (permissions) {
    permissions.forEach(permission => {
      let per = permission.name.split('-');

      const resource = per.shift()
      const action = per.join('-')

      can(action, resource);
    })
  }

  return rules;
}

export default ability;